import { IAdjustmentLogsSearchParam } from "src/Interfaces/applyOption";
import {
  IAdjustmentOrdersSearchParams,
  IExeOrderDTO,
  IExeStatusTableReport,
} from "../Interfaces/adjustment";
import { Packet } from "../Interfaces/commonDtos";
import {
  IDeltaHedgeExeDetailedStateTableReport,
  IDeltaHedgeExeDetailedStateTableSearchParam,
  IDeltaHedgeExeDetailedStateTradeTableSearchParam,
  IDetailedStateAdjustmentTablesSearchParam,
} from "../Interfaces/deltaHedgeExe";
import { Graph_Dto } from "../Interfaces/orderbookGraphInterfaces";
import { Report } from "../Interfaces/TableInterfaces";
import { getRequest, getTable, postRequest } from "./requestTemplates";
import { ITreeViewData } from "src/Components/TreeView/types";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { AxiosRequestConfig } from "axios";

export const getDeltaGraph = async (id: number): Promise<Array<Graph_Dto>> =>
  getRequest(`/v1/Adjustment/DeltaGraph?Id=${id}`);

export const getGammaGraph = async (id: number): Promise<Array<Graph_Dto>> =>
  getRequest(`/v1/Adjustment/GammaGraph?Id=${id}`);

export const getDailyLockProfitGraph = async (
  id: number
): Promise<Array<Graph_Dto>> =>
  getRequest(`/v1/Adjustment/DailyLockProfitGraph?Id=${id}`);

export const getPortfoValueGraph = async (
  id: number
): Promise<Array<Graph_Dto>> =>
  getRequest(`/v1/Adjustment/portfoValueGraph?Id=${id}`);

export const getDetailedStateAdjustmentOffsetDeltaGammaTable = (
  searchParam: IDetailedStateAdjustmentTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDetailedStateAdjustmentTablesSearchParam, any>(
    "/v1/Adjustment/Offer/OffsetDeltaGamma",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDetailedStateAdjustmentOffsetDeltaTable = (
  searchParam: IDetailedStateAdjustmentTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDetailedStateAdjustmentTablesSearchParam, any>(
    "/v1/Adjustment/Offer/OffsetDelta",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDetailedStateAdjustmentDeltaGammaTable = (
  searchParam: IDetailedStateAdjustmentTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDetailedStateAdjustmentTablesSearchParam, any>(
    "/v1/Adjustment/Offer/DeltaGamma",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDetailedStateAdjustmentDeltaTable = (
  searchParam: IDetailedStateAdjustmentTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDetailedStateAdjustmentTablesSearchParam, any>(
    "/v1/Adjustment/Offer/Delta",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDetailedStateAdjustmentEmergencyOffsetTable = (
  searchParam: IDetailedStateAdjustmentTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<IDetailedStateAdjustmentTablesSearchParam, any>(
    "/v1/Adjustment/Offer/EmergencyOffset",
    searchParam,
    offset,
    pageSize,
    sortingType
  );
export const getDeltaHedgeExeDetailedStateTable = (
  searchParam: IDeltaHedgeExeDetailedStateTableSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IDeltaHedgeExeDetailedStateTableReport>> =>
  getTable<
    IDeltaHedgeExeDetailedStateTableSearchParam,
    IDeltaHedgeExeDetailedStateTableReport
  >(
    "/v1/Adjustment/Status",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const getDeltaHedgeExeDetailedStateTradeTable = (
  searchParam: IDeltaHedgeExeDetailedStateTradeTableSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IDeltaHedgeExeDetailedStateTableReport>> =>
  getTable<
    IDeltaHedgeExeDetailedStateTradeTableSearchParam,
    IDeltaHedgeExeDetailedStateTableReport
  >("/v1/Adjustment/GetOrders", searchParam, offset, pageSize, sortingType);

export const getExeStatusTable = (
  searchParam: IDeltaHedgeExeDetailedStateTradeTableSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IExeStatusTableReport>> =>
  getTable<
    IDeltaHedgeExeDetailedStateTradeTableSearchParam,
    IExeStatusTableReport
  >(
    "/v1/Adjustment/getExeStatus",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const getExeStatusOrdersTable = (
  searchParam: IAdjustmentOrdersSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IDeltaHedgeExeDetailedStateTableReport>> =>
  getTable<
    IAdjustmentOrdersSearchParams,
    IDeltaHedgeExeDetailedStateTableReport
  >(
    "/v1/Adjustment/GetOrders",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const getExeStatusOrdersErrorsTable = (
  searchParam: IAdjustmentOrdersSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IDeltaHedgeExeDetailedStateTableReport>> =>
  getTable<
    IAdjustmentOrdersSearchParams,
    IDeltaHedgeExeDetailedStateTableReport
  >(
    "/v1/Adjustment/GetOrderErrors",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export const cancelOrders = (
  orderDTO: IExeOrderDTO
): Promise<Packet<boolean>> =>
  postRequest(`/v1/Adjustment/CancelOrder`, orderDTO);

export const sendOrders = (orderDTO: IExeOrderDTO): Promise<Packet<boolean>> =>
  postRequest(`/v1/Adjustment/SendOrder`, orderDTO);

export const getLogs = (
  dto: IAdjustmentLogsSearchParam
): Promise<ITreeViewData> => postRequest("/v1/adjustment/getlogs", dto);
